import React from 'react';
import { InteractionType, } from '@debbie/common/dist/interactions';
import AutoCall from './AutoCall';
import EBoksSummary from './EBoksSummary';
import EInvoiceSummary from './EInvoiceSummary';
import EmailSummary from './EmailSummary';
import LetterSummary from './LetterSummary';
import NoteSummary from './NoteSummary';
import PhoneSummary from './PhoneSummary';
import SMSSummary from './SMSSummary';
const InteractionSummary = (props) => {
    switch (props.interaction.type) {
        default:
        // Handle normal interaction stuff
        case InteractionType.Email:
            return (React.createElement(EmailSummary, { interaction: props.interaction, longCaseId: props.longCaseId, showThread: props.showThread, setShowThread: props.setShowThread, replying: props.replying, setReplying: props.setReplying }));
        case InteractionType.Letter:
            return React.createElement(LetterSummary, Object.assign({}, props));
        case InteractionType.Eboks:
            return (React.createElement(EBoksSummary, { interaction: props.interaction }));
        case InteractionType.Phone:
            return React.createElement(PhoneSummary, Object.assign({}, props));
        case InteractionType.SMS:
            return React.createElement(SMSSummary, Object.assign({}, props));
        case InteractionType.AutoCall:
            return React.createElement(AutoCall, Object.assign({}, props));
        case InteractionType.Note:
        case InteractionType.ClientNote:
        case InteractionType.DebtorNote:
            return React.createElement(NoteSummary, Object.assign({}, props));
        case InteractionType.EInvoice:
            return (React.createElement(EInvoiceSummary, { interaction: props.interaction }));
    }
};
export default InteractionSummary;
//# sourceMappingURL=InteractionSummary.js.map